export default "__VITE_ASSET__DdzfIPdN__"